export const ROLES = {
	SUPER_ADMIN: 1,
	USER_ADMIN: 2,
	VT_ADMIN: 3,
};

export const ROLE_LABELS = {
	[ROLES.SUPER_ADMIN]: 'Super Admin',
	[ROLES.USER_ADMIN]: 'Seller Admin',
	[ROLES.VT_ADMIN]: 'VT Admin',
};

const ALL_DASHBOARD_ROLES = [ROLES.SUPER_ADMIN, ROLES.USER_ADMIN, ROLES.VT_ADMIN];

export const ROUTE_ACCESS = {
	'/': ALL_DASHBOARD_ROLES,
	'/dashboard': ALL_DASHBOARD_ROLES,
	'/inventory': ALL_DASHBOARD_ROLES,
	'/categories': ALL_DASHBOARD_ROLES,
	'/sizes': ALL_DASHBOARD_ROLES,
	'/colors': ALL_DASHBOARD_ROLES,
	'/orders': ALL_DASHBOARD_ROLES,
	'/registered-user': ALL_DASHBOARD_ROLES,
	'/config': ALL_DASHBOARD_ROLES,
	'/uploads': ALL_DASHBOARD_ROLES,
	'/shipping-pincode': ALL_DASHBOARD_ROLES,
	'/offer-codes': ALL_DASHBOARD_ROLES,
	'/org-accounts': [ROLES.SUPER_ADMIN],
};

export const NAV_LINKS = [
	{ label: 'DASHBOARD', path: '/', roles: ALL_DASHBOARD_ROLES },
	{ label: 'Inventory', path: '/inventory', roles: ALL_DASHBOARD_ROLES },
	{ label: 'Categories', path: '/categories', roles: ALL_DASHBOARD_ROLES },
	{ label: 'Sizes', path: '/sizes', roles: ALL_DASHBOARD_ROLES },
	{ label: 'Colors', path: '/colors', roles: ALL_DASHBOARD_ROLES },
	{ label: 'Orders', path: '/orders', roles: ALL_DASHBOARD_ROLES },
	{ label: 'Registered Users', path: '/registered-user', roles: ALL_DASHBOARD_ROLES },
	{ label: 'Config', path: '/config', roles: ALL_DASHBOARD_ROLES },
	{ label: 'Uploads', path: '/uploads', roles: ALL_DASHBOARD_ROLES },
	{ label: 'Org Accounts', path: '/org-accounts', roles: [ROLES.SUPER_ADMIN] },
	{ label: 'Shipping Pincode', path: '/shipping-pincode', roles: ALL_DASHBOARD_ROLES },
	{ label: 'Offer Codes', path: '/offer-codes', roles: ALL_DASHBOARD_ROLES },
];

export const canAccessRoute = (roleId, path) => {
	const normalizedPath = path === '/' ? '/' : path.replace(/\/$/, '');
	const allowedRoles = ROUTE_ACCESS[normalizedPath];
	if (!allowedRoles) {
		return false;
	}
	return allowedRoles.includes(Number(roleId));
};

export const isSuperAdmin = (roleId) => Number(roleId) === ROLES.SUPER_ADMIN;

export const canSwitchAccounts = (roleId) => isSuperAdmin(roleId);
